import type {
  PropsWithChildren,
  ReactElement,
  ToggleEventHandler,
} from 'react';

import { AccordionRichDetails } from './AccordionItem.styled';

export type Props = {
  defaultOpen?: boolean;
  header?: ReactElement<'summary'>;
  qaId?: string;
  className?: string;
  id?: string;
  name?: string;
  onToggle?: ToggleEventHandler<HTMLDetailsElement>;
};

export function AccordionItem({
  defaultOpen,
  children,
  className,
  header,
  name,
  id,
  onToggle,
  qaId,
}: PropsWithChildren<Props>) {
  return (
    <AccordionRichDetails
      id={id}
      name={name}
      className={className}
      defaultOpen={defaultOpen}
      qaId={qaId}
      onToggle={onToggle}
    >
      {header}
      {children}
    </AccordionRichDetails>
  );
}
